// extracted by mini-css-extract-plugin
module.exports = {"notificationBox":"AddMultipleMembersModal_notificationBox_3hJT8","emailDomainsInfoBox":"AddMultipleMembersModal_emailDomainsInfoBox_jUReI"};